import { ArkActionTypes } from '../../../../../actions/dashboards/Ark'
import { Metrics } from '../../../../../constants/Dashboards'
import buildAsyncStatReducer from '../../asyncStatReducer'

export interface SessionSkuPayload {
    types: {
        [sku: string]: number
    }
}

interface SessionsSkuState {
    values: number[]
    labels: string[]
    total: number
    perc: null
    name: string
}

/**
 * Ark Sessions per Sku reducer
 */
const arkSessionsSku = buildAsyncStatReducer<SessionSkuPayload, SessionsSkuState>({
    key: Metrics.ARK_SESSIONS_SKU,
    types: ArkActionTypes.DASHBOARD_ARK_SESSIONS_SKU,
    transform: (state, { payload }) => {
        const { types: skusMap } = payload || {}
        const skusList: string[] = Object.keys(skusMap || {})

        const sortedList = skusList.sort((a: string, b: string): number => skusMap[b] - skusMap[a])

        return {
            values: sortedList.map((store) => skusMap[store]),
            labels: sortedList,
            total: skusList.length,
            perc: null,
            name: 'dashboard-count-interactions',
        }
    },
})

export default arkSessionsSku
